import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import ReactMarkdown from 'react-markdown';
import Button from "src/components/Button/Button";
import styled from "styled-components";
import { useTranslation } from 'react-i18next';
import { shouldPublish, getScheduleDates } from 'src/utils/publishUtils';
import ResponsiveImage from 'src/components/ImageWrapper/ResponsiveImage';

const SCHEDULE_KEY = "drunkenDragonClosingModal";

const DrunkenDragonClosingModal = () => {
  const [showModal, setShowModal] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const schedule = getScheduleDates(SCHEDULE_KEY);
    if (shouldPublish(schedule)) {
      setShowModal(true);
    }
  }, []);

  const handleClose = () => {
    setShowModal(false);
  };

  if (!showModal) return null;

  return (
    <StyledModal
      show={showModal}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      aria-labelledby="drunken-dragon-closing-modal-title"
      centered
      className="drunken-dragon-closing-modal"
    >
      <Modal.Header>
        <div className="d-flex w-100 align-items-middle justify-content-between">
            <Modal.Title id="drunken-dragon-closing-modal-title">
              {t("drunkenDragonClosingModal.title")}
            </Modal.Title>
            <ResponsiveImage
              src="svg/DRUNKEN_DRAGON_LOGO_REGISTERED_WHITE.svg"
              alt={t("dining.dining.drunkenDragon.logoAlt")}
              className="modal-logo"
            />
        </div>
      </Modal.Header>
      <Modal.Body className="light">
        <ReactMarkdown>
          {t("drunkenDragonClosingModal.paragraph1")}
        </ReactMarkdown>
        <p>{t("drunkenDragonClosingModal.paragraph2")}</p>
        <p>{t("drunkenDragonClosingModal.paragraph3")}</p>
        <ReactMarkdown>
          {t("drunkenDragonClosingModal.paragraph4")}
        </ReactMarkdown>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-end gap-2">
        <hr/>
        <Button
          className="m-0"
          href={t("drunkenDragonClosingModal.ctaLink")}
          bgColor="#b59771"
          color="var(--white)"
          hoverColor="#b59771"
          hoverBgColor="var(--white)"
          border="2px #b59771"
          label={t("drunkenDragonClosingModal.cta")}
        />
        <Button
          onClick={handleClose}
          border="2px #b59771"
          bgColor="var(--white)"
          color="#b59771"
          hoverColor="var(--white)"
          hoverBgColor="#b59771"
          label={t("drunkenDragonClosingModal.close")}
        />
      </Modal.Footer>
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  z-index: 9999 !important;
  .modal-header {
    background-color: #b59771;
    flex-direction: column;
    align-items: center;
    gap: 0.75rem;
    padding: 1.5rem 1rem 1rem;
    .modal-logo {
      max-height: 3rem;
      width: auto;
      margin: -0.5rem 0 0 0;
    }
    .modal-title {
      color: var(--white);
      font-weight: 700;
      text-align: left;
      flex-grow: 1;
    }
  }
  .modal-content, .modal-header {
    border-radius: 0;
  }
  .modal-body {
    padding-bottom: 0.4rem;
    p {
      margin-bottom: 1rem;
      font-size: 0.9rem;
    }
  }
  .modal-footer {
    button {
      margin: 0;
      border: none;
    }
  }
`;

export default DrunkenDragonClosingModal;
